import { render, staticRenderFns } from "./pickup.vue?vue&type=template&id=14058ffc&scoped=true&"
import script from "./pickup.vue?vue&type=script&lang=js&"
export * from "./pickup.vue?vue&type=script&lang=js&"
import style0 from "./pickup.vue?vue&type=style&index=0&id=14058ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14058ffc",
  null
  
)

export default component.exports